import { Link } from 'react-router-dom';
import { ShieldCheck, ShoppingCart } from 'lucide-react';
import { useCart } from '@/context/CartContext';
import { formatPrice } from '@/lib/api';
import { toast } from 'sonner';

export function ProductCard({ product }) {
    const { add } = useCart();
    const handleAdd = (e) => {
        e.preventDefault();
        e.stopPropagation();
        add(product, 1);
        toast.success(`Added to cart: ${product.name}`);
    };
    return (
        <Link
            to={`/product/${product.id}`}
            data-testid="catalog-product-card"
            className="group rrm-panel overflow-hidden hover:border-white/20 transition-colors flex flex-col"
        >
            <div className="aspect-[4/3] bg-black/40 overflow-hidden">
                <img
                    src={product.image_url}
                    alt={product.name}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-300"
                />
            </div>
            <div className="p-4 flex flex-col gap-2 flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                    <span
                        className={`text-[10px] px-2 py-0.5 rounded-full border ${
                            product.part_type === 'oem'
                                ? 'bg-white/5 border-white/15 text-white/80'
                                : 'bg-rose-500/10 border-rose-500/30 text-rose-200'
                        }`}
                    >
                        {product.part_type === 'oem' ? 'OEM' : 'UPGRADE'}
                    </span>
                    {product.vin_verified && (
                        <span className="text-[10px] px-2 py-0.5 rounded-full border bg-emerald-500/10 border-emerald-500/30 text-emerald-200 inline-flex items-center gap-1">
                            <ShieldCheck className="w-3 h-3" /> VIN VERIFIED
                        </span>
                    )}
                </div>
                <div className="text-sm font-semibold text-white line-clamp-2 min-h-[2.5rem]" data-testid="product-name">
                    {product.name}
                </div>
                <div className="text-xs text-white/50 line-clamp-1">{product.brand} · {product.category}</div>
                <div className="mt-auto flex items-center justify-between pt-3">
                    <div className="font-display text-2xl text-amber-400" data-testid="product-price">{formatPrice(product.price)}</div>
                    <button
                        data-testid="catalog-add-to-cart-button"
                        onClick={handleAdd}
                        className="inline-flex items-center gap-1 px-3 py-1.5 rounded-md bg-[var(--rrm-red)] hover:bg-[var(--rrm-red2)] text-white text-xs"
                    >
                        <ShoppingCart className="w-3.5 h-3.5" /> Add
                    </button>
                </div>
            </div>
        </Link>
    );
}
